







































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { devicePriceList } from '../types';

const name = 'ttam-device-price-range';
export default defineComponent({
  name,
  props: {
    value: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    minOptions: {
      type: Array as PropType<devicePriceList>,
      default: () => [],
    },
    maxOptions: {
      type: Array as PropType<devicePriceList>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const minPrice = computed({
      get: () => props.value?.[0],
      set: val => {
        const newLaunchPrice = [val, props.value?.[1]];
        emit('input', newLaunchPrice);
        emit('change', newLaunchPrice);
      },
    });
    const maxPrice = computed({
      get: () => props.value?.[1],
      set: val => {
        const newLaunchPrice = [props.value?.[0], val];
        emit('input', newLaunchPrice);
        emit('change', newLaunchPrice);
      },
    });
    return {
      name,
      minPrice,
      maxPrice,
    };
  },
});
